/** Portfolio chip (ADR-0019 §2): the label accountable for a family (`ROLE_PORTFOLIO`). A label, never an edit right. */
import { ROLE_PORTFOLIO, type TeamRole } from "@bsim/contracts";
import type { DecisionFamily } from "@bsim/domain";
import { useDeskLabel } from "../../shell/desks";
import { roleLabel } from "../../shell/TopBar";

const portfolioOf = (role: TeamRole): readonly DecisionFamily[] => (ROLE_PORTFOLIO as Partial<Record<TeamRole, readonly DecisionFamily[]>>)[role] ?? [];

export function PortfolioChips({ role }: { readonly role: TeamRole }) {
  const desk = useDeskLabel();
  const families = portfolioOf(role);
  if (families.length === 0) return <></>;
  return <span className="gx-decide-port" data-testid="decide.portfolio" title={`Accountable for ${families.map((f) => desk(f)).join(" and ")}. Anyone can still edit.`}>{roleLabel(role)}</span>;
}
